<div class="me-calendar">
    <mat-calendar [selected]="selectedDate" [minDate]="minDate" [maxDate]="maxDate"
        (selectedChange)="dateSelected($event)" [headerComponent]="entityCalendarHeader"></mat-calendar>

    <!-- <mat-form-field class="hidden-input" style="display:none">
        <input matInput [matDatepicker]="picker" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker [calendarHeaderComponent]="entityCalendarHeader"
            (selectedChange)="dateSelected($event)">
        </mat-datepicker>
    </mat-form-field> -->


    <!-- <mat-form-field>
        <mat-label>Custom calendar header</mat-label>
        <input matInput [matDatepicker]="picker" >
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker [calendarHeaderComponent]="exampleHeader"></mat-datepicker>
    </mat-form-field> -->
</div>